import { Product } from 'common/components/product-card/types';
import { isFullProduct } from '../../utils';
import { UnifiedCompareGroup } from '../../types';

export function checkCachedData(currentGroup: UnifiedCompareGroup | null, productIds: string[]) {
  if (!currentGroup?.isDataLoaded) return null;

  const hasAllProducts = productIds.every((productId) => {
    const product = currentGroup.productsData[productId];
    return product && isFullProduct(product as Product);
  });

  if (!hasAllProducts) return null;

  const fullProductsData: Record<string, Product> = {};
  Object.entries(currentGroup.productsData).forEach(([productId, product]) => {
    if (isFullProduct(product as Product)) {
      fullProductsData[productId] = product as Product;
    }
  });

  return fullProductsData;
}

export function extractProductsFromResponse(compareDataResponse: {
  content?: Product[];
}): Record<string, Product> {
  const productsData: Record<string, Product> = {};

  if (compareDataResponse?.content) {
    compareDataResponse.content.forEach((product: Product) => {
      if (product.productId) {
        productsData[product.productId] = product;
      }
    });
  }

  return productsData;
}
